export type AvailsPlusAirtableSourceKey = "test" | "svod";

export interface AvailsPlusAirtableSourceOption {
    key: AvailsPlusAirtableSourceKey;
    label: string;
}

/** Mirrors backend AVAILS_TEST_WORKSPACE — test workspace only when explicitly "true". */
export const isAvailsTestWorkspaceEnabled =
    String(process.env.AVAILS_TEST_WORKSPACE || "")
        .trim()
        .toLowerCase() === "true";

const ALL_AVAILS_PLUS_AIRTABLE_SOURCES: AvailsPlusAirtableSourceOption[] = [
    { key: "test", label: "Wonder Programming ( Test )" },
    { key: "svod", label: "SVOD Programming" },
];

export const AVAILS_PLUS_AIRTABLE_SOURCES: AvailsPlusAirtableSourceOption[] =
    ALL_AVAILS_PLUS_AIRTABLE_SOURCES.filter(
        (source) => source.key !== "test" || isAvailsTestWorkspaceEnabled
    );

export const DEFAULT_AVAILS_PLUS_AIRTABLE_SOURCE: AvailsPlusAirtableSourceKey =
    "svod";

export function getAvailsPlusAirtableSourceLabel(
    key: AvailsPlusAirtableSourceKey
): string {
    return (
        ALL_AVAILS_PLUS_AIRTABLE_SOURCES.find((source) => source.key === key)
            ?.label ?? key
    );
}

export function isAvailsPlusAirtableSourceKey(
    value: string
): value is AvailsPlusAirtableSourceKey {
    return AVAILS_PLUS_AIRTABLE_SOURCES.some((source) => source.key === value);
}
